import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchAllVideos, sendVote} from "../NewYearEvent/eventSlice";
import {ReactComponent as MarkSVG} from '../../../assets/img/mark.svg'
import {ReactComponent as RectangleSVG} from '../../../assets/img/rectangle.svg'
import styles from "./allVideos.module.css";
import GoBack from "../../subsidiary/GoBack/GoBack";


const AllVideos = () => {
    const contestID = localStorage.getItem('contestID');
    const token = localStorage.getItem('token');
    const videos = useSelector((state) => state.eventSlice.contestVideos);
    const dispatch = useDispatch();
    const [selectedVideoId, setSelectedVideoId] = useState(null);
    const handleSendVote = () => {
        if (selectedVideoId) {
            dispatch(sendVote({ contestID, token, team: selectedVideoId })).then((params) => {
                if (params.error) {
                    window.showAlert({ title: 'Что-то пошло не так', type: 'error' });
                } else {
                    window.showAlert({ title: 'Спасибо! Ваш голос учтен!', type: 'success' });
                }
                dispatch(fetchAllVideos({ token, contestID }));
                setSelectedVideoId(null)
            });
        }
    };

    useEffect(() => {
        dispatch(fetchAllVideos({ token, contestID }));
    }, [dispatch]);

    const isVideoSelected = (videoId) => selectedVideoId === videoId;

    const selectVideo = (videoId) => {
        setSelectedVideoId(videoId);
    };

    return (
        <section className="main">
            <div className="content-wrapper">
                <GoBack nav={-1} text={'На главную'} />
                <div className="page-title-container">
                    <h1 className="page-title">
                        Проголосовать за видео
                    </h1>
                </div>
                {videos.length === 0 ? (
                    <div className={styles.emptyVideos}>Пока еще нет доступных видео</div>
                ) : (
                    videos.map((video) => (
                        <div key={video.id}>
                            <video controls width="100%" height="360" style={{marginBottom: '25px'}}>
                                <source src={video.team_media.image} type="video/mp4" />
                            </video>
                            <span className={styles.categhory}>Категория «{video.purpose.name}»</span>
                            <div
                                className={styles.choseVideo}
                                onClick={() => selectVideo(video.id)}
                            >
                                {isVideoSelected(video.id) || video.voted ? (
                                    <MarkSVG />
                                ) : (
                                    <RectangleSVG />
                                )}
                                <span style={{ marginLeft: '15px', fontSize: '14px' }}>
                  {video.voted ? 'Вы проголосовали' : 'Выбрать видео'}
                </span>
                            </div>
                        </div>
                    ))
                )}

                <div className={styles.conditionBtnContainer}>
                    {selectedVideoId && (
                        <button
                            className={styles.conditionBtn}
                            onClick={handleSendVote}
                        >
                            Проголосовать
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
};

export default AllVideos;